import { AppRole } from "@/models/app/role";

export interface AppUser {
  id: number | null;
  role_id: number | null;
  name: string;
  email: string;
  password: string;
  password_confirmation: string;
  is_consent: boolean;
  is_verified: boolean;
  created_at: string;
  updated_at: string;
  role: AppRole;
}

export class AppUser implements AppUser {
  public id: number | null;
  public role_id: number | null;
  public name: string;
  public email: string;
  public password: string;
  public password_confirmation: string;
  public is_consent: boolean;
  public is_verified: boolean;
  public created_at: string;
  public updated_at: string;
  public role: AppRole;

  public constructor() {
    this.id = null;
    this.role_id = null;
    this.name = "";
    this.email = "";
    this.password = "";
    this.password_confirmation = "";
    this.is_consent = false;
    this.is_verified = false;
    this.created_at = "";
    this.updated_at = "";
    this.role = new AppRole();
  }
}
